import { API } from './api'
import { Api } from './apiServer'

export const normalizeMemberAddresses = (payload) => {
    if (!payload) return []

    if (Array.isArray(payload)) return payload

    if (Array.isArray(payload?.data)) return payload.data

    if (Array.isArray(payload?.data?.data)) return payload.data.data

    if (Array.isArray(payload?.rows)) return payload.rows

    return []
}

export const hasUsableAddress = (address) => {
    if (!address || typeof address !== 'object') return false

    return Boolean(
        address.address_id ||
        address.address_name ||
        address.full_address ||
        address.coordinate
    )
}

export const getMemberAddresses = async () => {
    const params = {
        access: 'auth',
        method: API.ADDRESS.type,
        url: API.ADDRESS.url,
        reqBody: {}
    }

    const response = await Api(params)

    if (!response?.status) {
        throw new Error(response?.message || 'Gagal memeriksa alamat pengiriman')
    }

    return normalizeMemberAddresses(response.data).filter(hasUsableAddress)
}
